import { FilterableApiStatus } from '../api/transportOrderApi';
import { TransportAssignmentStatus } from './transportAssignment.types';
import { TableCategory } from './tableCategory.types';

export const mapCategoryToFilterableStatus = (
    uiStatuses: TransportAssignmentStatus[],
    category: TableCategory,
): FilterableApiStatus[] => {
    switch (category) {
        case TableCategory.INBOX:
            if (uiStatuses.length > 0) {
                return uiStatuses.map(mapUIStatusToFilterableStatus);
            } else {
                return [
                    FilterableApiStatus.CANCELLATION,
                    FilterableApiStatus.CONFIRMED,
                    FilterableApiStatus.UNCONFIRMED,
                ];
            }
        case TableCategory.EN_ROUTE:
            return [FilterableApiStatus.LOADED];
        case TableCategory.FINISHED:
            return [FilterableApiStatus.UNLOADED];
        case TableCategory.ARCHIVE:
            return [];
    }
};

const mapUIStatusToFilterableStatus = (uiStatus: TransportAssignmentStatus): FilterableApiStatus => {
    switch (uiStatus) {
        case TransportAssignmentStatus.CANCELLATION:
            return FilterableApiStatus.CANCELLATION;
        case TransportAssignmentStatus.COMPLETE_CONFIRMED:
        case TransportAssignmentStatus.INCOMPLETE_CONFIRMED:
            return FilterableApiStatus.CONFIRMED;
        case TransportAssignmentStatus.UNCONFIRMED:
            return FilterableApiStatus.UNCONFIRMED;
        case TransportAssignmentStatus.LOADED:
            return FilterableApiStatus.LOADED;
        case TransportAssignmentStatus.UNLOADED:
            return FilterableApiStatus.UNLOADED;
    }
};
